import { render, staticRenderFns } from "./menuNotifications.vue?vue&type=template&id=2ea4415c&scoped=true&lang=pug"
import script from "./menuNotifications.vue?vue&type=script&lang=js"
export * from "./menuNotifications.vue?vue&type=script&lang=js"
import style0 from "./menuNotifications.vue?vue&type=style&index=0&id=2ea4415c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4415c",
  null
  
)

export default component.exports